import { CSSProperties } from 'react';

export const pricingCombinationsStyle: CSSProperties = {
  marginTop: 16,
};

export const pricingCombinationsHeaderStyle: CSSProperties = {
  marginBottom: 12,
};

export const pricingCombinationsHelpStyle: CSSProperties = {
  display: 'block',
  marginBottom: 8,
};

export const pricingCombinationsTableStyle: CSSProperties = {
  borderRadius: 8,
  overflow: 'hidden',
};

export const optionTagStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 32,
  height: 32,
  borderRadius: 8,
  backgroundColor: '#f1f5f9',
  color: '#475569',
  fontWeight: 600,
  fontSize: 13,
  border: 'none',
  margin: 0,
  lineHeight: 1,
};

export const durationContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  alignItems: 'flex-start',
};

export const durationRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
};

export const durationInputStyle: CSSProperties = {
  width: 60,
};

export const durationUnitStyle: CSSProperties = {
  color: '#94a3b8',
  fontSize: 12,
  whiteSpace: 'nowrap',
  minWidth: 22,
};

export const addButtonStyle: CSSProperties = {
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 8,
  fontWeight: 500,
};
